import axios from 'axios';

/**
 * Serviço para busca de endereços usando a API própria
 */

const ENDPOINT = 'https://busca.precodogas.com.br/geolocalizacao/';

/**
 * Busca sugestões de endereços baseado em um texto de entrada
 * @param {string} pesquisa - Texto digitado pelo usuário
 * @returns {Promise<Array>} - Array de sugestões de endereços
 */
export const searchAddresses = async (pesquisa) => {
  if (!pesquisa || pesquisa.length < 3) return { resultados: [] };

  try {
    const response = await axios.post(
      ENDPOINT,
      { logradouro: pesquisa },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data || { resultados: [] };
  } catch (error) {
    console.error('Erro ao buscar endereços na API:', error);
    throw error;
  }
};

/**
 * Formata o endereço completo para exibição
 * @param {Object} address - Objeto de endereço retornado pela API
 * @returns {string} - Endereço formatado
 */
export const formatAddress = (address) => {
  if (!address) return '';
  
  const parts = [
    address.logradouro,
    address.complemento,
    address.localidade,
    address.UF,
    address.CEP
  ].filter(Boolean);
  
  return parts.join(', ');
};

/**
 * Formata o endereço para exibição curta (apenas logradouro e cidade)
 * @param {Object} address - Objeto de endereço retornado pela API
 * @returns {string} - Endereço formatado curto
 */
export const formatShortAddress = (address) => {
  if (!address) return '';
  
  const parts = [
    address.logradouro,
    address.localidade
  ].filter(Boolean);
  
  return parts.join(', ');
};

/**
 * Mapeia o resultado da API para o formato esperado pelo componente
 * @param {Object} result - Um resultado da API de endereços
 * @returns {Object} - Objeto formatado para o componente
 */
export const mapResultToPlaceDetails = (result) => {
  if (!result) return null;
  
  return {
    placeId: `${result.latitude}-${result.longitude}`,
    formattedAddress: formatAddress(result),
    logradouro: result.logradouro.split(',')[0].trim(),
    numero: '', // A API não retorna número separadamente
    bairro: '',
    cidade: result.localidade,
    estado: result.UF,
    cep: result.CEP,
    latitude: result.latitude,
    longitude: result.longitude
  };
};

export default {
  searchAddresses,
  formatAddress,
  formatShortAddress,
  mapResultToPlaceDetails
};
